let baseUrl = {
    basicApi: process.env.VUE_APP_BASE_URL // 接口API
}

export default baseUrl

